function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
  fill: "#EAA622"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.55,
  d: "M119.738 62.1685L92.9272 41.707L26.3418 84.1461L53.6184 118.988C56.0784 119.288 58.5984 119.469 61.1784 119.469C93.0984 119.469 119.078 93.9685 119.738 62.1685Z",
  fill: "#BF830D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.4502 27.4482H91.0904V91.0885H27.4502V27.4482Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.4502 27.4482H91.0904V37.308H27.4502V27.4482Z",
  fill: "#D7D7D7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6422 27.8973V36.8607H27.8983V27.8973H90.6422ZM91.5385 27.001H27.002V37.7571H91.5385V27.001Z",
  fill: "#D7D7D7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7186 48.5127H50.3039V52.0981H46.7186V48.5127ZM61.06 48.5127H64.6454V52.0981H61.06V48.5127ZM68.2308 48.5127H71.8161V52.0981H68.2308V48.5127ZM75.4015 48.5127H78.9869V52.0981H75.4015V48.5127ZM39.5479 55.6834H43.1332V59.2688H39.5479V55.6834ZM46.7186 55.6834H50.3039V59.2688H46.7186V55.6834ZM61.06 55.6834H64.6454V59.2688H61.06V55.6834ZM68.2308 55.6834H71.8161V59.2688H68.2308V55.6834ZM75.4015 55.6834H78.9869V59.2688H75.4015V55.6834ZM39.5479 70.0249H43.1332V73.6103H39.5479V70.0249ZM46.7186 70.0249H50.3039V73.6103H46.7186V70.0249ZM61.06 70.0249H64.6454V73.6103H61.06V70.0249ZM53.8893 48.5127H57.4747V52.0981H53.8893V48.5127ZM53.8893 55.6834H57.4747V59.2688H53.8893V55.6834ZM39.5479 62.8542H43.1332V66.4395H39.5479V62.8542ZM46.7186 62.8542H50.3039V66.4395H46.7186V62.8542ZM61.06 62.8542H64.6454V66.4395H61.06V62.8542ZM68.2308 62.8542H71.8161V66.4395H68.2308V62.8542ZM75.4015 62.8542H78.9869V66.4395H75.4015V62.8542ZM53.8893 62.8542H57.4747V66.4395H53.8893V62.8542ZM53.8893 70.0249H57.4747V73.6103H53.8893V70.0249ZM68.2308 70.0249H71.8161V73.6103H68.2308V70.0249Z",
  fill: "#D7D7D7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8965 86.1592H90.6404V90.6409H27.8965V86.1592Z",
  fill: "#D7D7D7"
});

var SvgOnlineRecurring = function SvgOnlineRecurring(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnlineRecurring, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/online_recurring.bd8c16f4.svg";
export { ForwardRef as ReactComponent };